module.exports = __webpack_public_path__ + "img/model9_zh.62b9f253.png";